// Coding query/mutation key constants (Wave 2 · C1, OpenSpec
// `monorepo-wave-2-coding-pilot`). Definitions moved here verbatim from their
// hook/feature modules (which re-export — the GET_USER pattern); the strings
// are cache identities and are FROZEN: renaming one orphans every user's
// query cache. Enumerated by `pnpm coding:move-plan` (keys-census.json).

/** GET /session/{id}/clinical-codes — `useQuerySessionClinicalCodes` (app-side hook half). */
export const GET_SESSION_CLINICAL_CODES = `get_session_clinical_codes`;

/**
 * TanStack mutation scope shared by every write to a session's clinical codes
 * (confirm / unconfirm / reject / add). Scoped mutations run in serial, so a
 * fast toggle can no longer put two requests in flight at once.
 *
 * That matters because each backend handler read-modify-writes the *whole*
 * `clinical_entities` array, so with concurrent requests the slower one wins
 * regardless of send order: confirm-then-unconfirm left the code CONFIRMED
 * (TC203/SWR-66 e2e failure).
 *
 * ponytail: one global scope, not per-session — only one coding panel is open
 * at a time. Key it on sessionId if two panels ever need to write in parallel.
 */
export const SESSION_CLINICAL_CODES_MUTATION_SCOPE = 'session-clinical-codes';

/** Debounced code search — `useClinicalCodeSearch`. */
export const SEARCH_CLINICAL_CODES_QUERY_KEY = 'search_clinical_codes';

/** Imperative code search mutation — `useMutateSearchClinicalCodes`. */
export const SEARCH_CLINICAL_CODES = 'SEARCH_CLINICAL_CODES';

/** Regenerate-codes mutation — `useMutateRegenerateCodes`. */
export const REGENERATE_CODES_KEY = 'regenerate-codes';

/** Coding-case detail — `codingCase/query-keys.ts`. */
export const GET_CODING_CASE = 'coding-case';

/** Coding-case revision list — `codingCase/query-keys.ts`. */
export const GET_CODING_CASE_REVISIONS = 'coding-case-revisions';

/** Coding-case Ask Heidi thread — hydrates the per-case atom on page load. */
export const GET_CODING_CASE_CHAT_HISTORY = 'coding-case-chat-history';

/** Coding-dashboard case table — `codingDashboard/query-keys.ts`. */
export const GET_CODING_DASHBOARD_CASES = 'coding-dashboard-cases';

/** Case-feedback preference cache — `useCodingCaseFeedback`. */
export const GET_CODING_FEEDBACK_PREFERENCE = ['codingFeedbackPreference'] as const;
